import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=6633d415&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=js&"
export * from "./BaseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633d415",
  null
  
)

export default component.exports